// This file is generated by icon spritesheet generator

export const iconNames = [
  "x",
  "wallet",
  "user-circle",
  "trash",
  "tools-kitchen-2",
  "sun",
  "search",
  "scooter",
  "refresh",
  "plus",
  "pencil",
  "password-user",
  "notes",
  "moon",
  "minus",
  "mail",
  "logout",
  "lock",
  "lock-open",
  "link",
  "icons-off",
  "help",
  "grip-vertical",
  "file-unknown",
  "file-text",
  "edit",
  "download",
  "dots",
  "device-laptop",
  "cookie",
  "code",
  "clock",
  "chevron-up",
  "chevron-right",
  "chevron-left",
  "chevron-down",
  "check",
  "chart-bar",
  "category-2",
  "camera",
  "calendar",
  "bus",
  "building-warehouse",
  "brand-github",
  "arrows-right-left",
  "arrow-right",
  "arrow-left",
] as const

export type IconName = typeof iconNames[number]
